module.exports = __webpack_public_path__ + "1426c20ef0643512703fc919b7d07117.png";